import { useProtectedAPI } from "./apiService";
import { objectToQueryString } from "@/utils/objectToQueryString";
import useSWR from "swr";

export const useAdminGetCompetitionsSWR = () => {

    const protectedApi = useProtectedAPI();
    const fetcher = (url) => protectedApi.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR("/admin/competitions", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useAdminGetCompetitions = () => {
    const protectedAPI = useProtectedAPI()

    const adminGetCompetitions = async (filters) => {
        const queryString = objectToQueryString(filters)
        const url = `/admin/competitions?${queryString}`
        const response = await protectedAPI.get(url)
        return response.data
    }
    
    return adminGetCompetitions
}



export const useAdminGetCompetition = () => {
    const protectedAPI = useProtectedAPI()

    const adminGetCompetition = async (id) => {
        const response = await protectedAPI.get(`/admin/competitions/${id}`)
        return response.data
    }

    return adminGetCompetition
}



export const useAdminCreateCompetition = () => {
    const protectedAPI = useProtectedAPI();

    const adminCreateCompetition = async (data) => {

        if (data.default === false) data.default = null

        const response = await protectedAPI.post(`/admin/competitions`, data)
        return response.data
    };

    return adminCreateCompetition;
}



export const useAdminUpdateCompetition = () => {
    const protectedAPI = useProtectedAPI();

    const adminUpdateCompetition = async (id, data) => {

        if (data.default === false) data.default = null
        
        const response = await protectedAPI.put(`/admin/competitions/${id}`, data)
        return response.data
    };

    return adminUpdateCompetition;
}



export const useAdminDeleteCompetition = () => {
    const protectedAPI = useProtectedAPI();

    const adminDeleteCompetition = async (id) => {
        const response = await protectedAPI.delete(`/admin/competitions/${id}`)
        return response.data
    };

    return adminDeleteCompetition;
}
